import wrapError from "@/components/helpers/wrapError"

export const apiRecordUserAction = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/userAction",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiRecordUserAction"),
  })
}
